const Shadow = () => {
  return <div className="uic-timeline-shadow"></div>;
};

export default Shadow;
